import Api from "@/repository/api";
import {ResponseDataType} from "@/form/form.types";
import VacancySection from "@/entity/Settings/vacancy_section";
import { IVacancySection, IVacancySectionListItem, VacancySectionResponseType } from "@/entity/Settings/vacancy_section.types";
import { IVacancySectionRepository } from "./VacancySectionRepository.types";
import {PaginationRequestType} from "@/entity/common/pagination.types";
import qs from "qs";
import { SiteVacancySectionRequestType } from "@/form/Settings/site/vacancy_section.types";

export class VacancySectionRepository implements IVacancySectionRepository {
    async fetchAll(data?: FormData): Promise<IVacancySection> {
        const response = await Api.get('/settings/vacancy_section/get', { 
            params: data, 
            paramsSerializer: function paramsSerializer(params) {
            return new URLSearchParams(params).toString()
            }});
        const responseData = response.data as VacancySectionResponseType;
        return new VacancySection(responseData);
    }

    async fetchData(data: PaginationRequestType): Promise<IVacancySectionListItem> {

        const response = await Api.get(`/settings/vacancy_section/get`, {
            params: data, paramsSerializer: function paramsSerializer(params) {
                return qs.stringify(params, {arrayFormat: 'repeat'})
            }});

        const responseData = response.data as VacancySectionResponseType;

        return new VacancySection(responseData).data[0];
    }

    async create(data: SiteVacancySectionRequestType): Promise<ResponseDataType> {
        const response = await Api.post('/settings/vacancy_section/createOrUpdate', data);
        return response.data;
    }

}